import React from 'react';

import {Text} from '@albert-io/atomic';
import albeyZuriHighFive from 'assets/images/albey/albey-zuri-high-five.svg';

interface OnboardingPageLayoutProps {
  children: React.ReactNode;
}

export default function OnboardingPageLayout({children}: OnboardingPageLayoutProps) {
  return (
    <div className='flex w-full flex-col justify-center px-x4 pt-x4 m:flex-row m:gap-x8 m:px-x12 m:pt-x7'>
      <div className='hidden flex-col items-center gap-x5 px-x4 py-x3 m:flex m:w-[400px] m:shrink-0'>
        <div className='relative flex items-center justify-center'>
          <img src={albeyZuriHighFive} alt='' aria-hidden='true' />
        </div>
        <div className='flex w-full flex-col gap-x5'>
          <Text className='text-center text-heading-l font-black'>
            Welcome to Albert, let&apos;s get you started!
          </Text>
        </div>
      </div>

      <div className='flex w-full flex-col gap-x5 pb-x4 m:max-w-[650px] m:min-w-[580px] m:shrink-0 m:px-x4 m:py-x3'>
        {children}
      </div>
    </div>
  );
}
